export default __webpack_public_path__ + "static/media/img-0127-france-premium-face.71fa528a.png";